import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback } from 'react';
import { useAppContext } from '@magento/peregrine/lib/context/app';
import { useDropdown } from '@magento/peregrine/lib/hooks/useDropdown';
export var useHeader = function useHeader() {
  var _useAppContext = useAppContext(),
      _useAppContext2 = _slicedToArray(_useAppContext, 1),
      _useAppContext2$ = _useAppContext2[0],
      hasBeenOffline = _useAppContext2$.hasBeenOffline,
      isOnline = _useAppContext2$.isOnline,
      isPageLoading = _useAppContext2$.isPageLoading;

  var _useDropdown = useDropdown(),
      searchRef = _useDropdown.elementRef,
      isSearchOpen = _useDropdown.expanded,
      setIsSearchOpen = _useDropdown.setExpanded,
      searchTriggerRef = _useDropdown.triggerRef;

  var handleSearchTriggerClick = useCallback(function () {
    // Toggle the Search input form.
    setIsSearchOpen(function (isOpen) {
      return !isOpen;
    });
  }, [setIsSearchOpen]);
  return {
    handleSearchTriggerClick: handleSearchTriggerClick,
    hasBeenOffline: hasBeenOffline,
    isOnline: isOnline,
    isPageLoading: isPageLoading,
    isSearchOpen: isSearchOpen,
    searchRef: searchRef,
    searchTriggerRef: searchTriggerRef
  };
};